"use strict";

const atob = require("./lib/atob");
const btoa = require("./lib/btoa");

module.exports = {
  atob,
  btoa
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_abab@2.0.5@abab/index.js
// module id = quVB
// module chunks = 0